import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { View } from 'react-native';

import { ButtonGroup, Button } from 'app/src/elements/buttons';
import Input from 'app/src/elements/inputs';
import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';

import { UPDATE_CURRENT_SELLER } from './queries';

const Settings = ({setShowModal}) => {
  const { user, refetchData } = useContext(AuthContext);

  const [updateCurrentSeller] = useMutation(UPDATE_CURRENT_SELLER, {
    onCompleted: () => {
      refetchData();
      setShowModal(false);
    }
  });

  const { control, reset, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      clientNumberLabel: user.seller.clientNumberLabel,
    }
  });

  const onSubmit = (data) => {
    updateCurrentSeller({ variables: data });
  };

  return (
    <View>
      <Input.Text
        label="Alternate Label for Client Number:"
        name="clientNumberLabel"
        control={control}
        errors={errors}
      />
      <View>
        <ButtonGroup>
          <Button label="Submit" onPress={handleSubmit(onSubmit)} />
        </ButtonGroup>
      </View>
    </View>
  );
};

export default Settings;
